// extracted by mini-css-extract-plugin
export var root = "XfER";
export var rootCard = "oyAJ";
export var rootCardCategory = "i2ay";
export var rootCardDate = "_0Pe9";
export var rootCardDateHidden = "P96g";
export var rootCardDescription = "Iijx";
export var rootCardDetails = "nyLt";
export var rootCardHeading = "LZoS";
export var rootCardImage = "atkF";
export var rootCardPicture = "Jkvd";
export var rootCardPicturePlaceholder = "i5B8";
export var rootCardReadTime = "VMEj";
export var rootCardReadTimeIcon = "_30FN";
export var rootCardReadTimeWrapper = "Be2a";